export default "__VITE_ASSET__VPuFLqVG__"